var router = [{
  id: 1,
  name: "首页配置",
  path: "",
  children: [{
    id: 2,
    name: "公告分类",
    path: "/indexDisposition/announceType"
  }, {
    id: 3,
    name: "公告列表",
    path: "/indexDisposition/announceList"
  }, {
    id: 4,
    name: "轮播图",
    path: "/indexDisposition/topBanner"
  }, {
    id: 5,
    name: "社交渠道",
    path: "/indexDisposition/socialChannel"
  }, {
    id: 7,
    name: "人物轮播",
    path: "/indexDisposition/personCast"
  }, {
    id: 13,
    name: "宗门弟子",
    path: "/indexDisposition/disciple"
  }, {
    id: 6,
    name: "下载地址",
    path: "/indexDisposition/downloadAddress"
  }, {
    id: 8,
    name: "评论管理",
    path: "/indexDisposition/commentList"
  }]
}, {
  id: 13,
  name: "预约H5配置",
  path: "",
  children: [{
    id: 14,
    name: "用户列表",
    path: "/reservation/userList"
  }, {
    id: 15,
    name: "奖品总量",
    path: "/reservation/lotteryNumData"
  }, {
    id: 16,
    name: "兑换码",
    path: "/reservation/lotteryCodeData"
  }, {
    id: 17,
    name: "每日福利兑换码",
    path: "/reservation/dailyWelfare"
  }]
}, {
  id: 7,
  name: "访问数据",
  path: "",
  children: [{
    id: 8,
    name: "首页访问/下载",
    path: "/interviewData/indexInterview"
  } // , {
  //   "id": 6,
  //   "name": "下载链接",
  //   "path": "/interviewData/downloadInterview.vue",
  // }
  ]
}, {
  id: 9,
  name: "公告管理",
  path: "",
  children: [{
    id: 10,
    name: "登陆前公告",
    path: "/announcement/beforeLogin"
  }, {
    id: 11,
    name: "游戏内公告",
    path: "/announcement/InGame"
  }, {
    id: 12,
    name: "服务器状态",
    path: "/announcement/serverAd"
  }]
}];
export default router;